"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_1 = __importDefault(require("@emotion/styled"));

var getParents = function getParents(productGroup, productGroups) {
  var parents = [];

  if (!productGroup) {
    return parents;
  }

  if (productGroup.parentId) {
    var parent_1 = productGroups.find(function (pg) {
      return pg.id === productGroup.parentId;
    });
    parents = getParents(parent_1, productGroups);
  }

  parents.push(productGroup);
  return parents;
};

var StyledBreadcrumbs = styled_1.default.nav(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: lightgrey;\n  font-size: 14px;\n"], ["\n  color: lightgrey;\n  font-size: 14px;\n"])));
var Breadcrumb = styled_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-right: 10px;\n  opacity: 0.6;\n\n  &::after {\n    content: '>';\n    display: inline-block;\n    margin-left: 10px;\n  }\n\n  &:last-child::after {\n    display: none;\n  }\n"], ["\n  margin-right: 10px;\n  opacity: 0.6;\n\n  &::after {\n    content: '>';\n    display: inline-block;\n    margin-left: 10px;\n  }\n\n  &:last-child::after {\n    display: none;\n  }\n"])));

exports.Breadcrumbs = function (_a) {
  var breadcrumbs = _a.breadcrumbs,
      node = _a.node;
  return react_1.default.createElement(StyledBreadcrumbs, null, breadcrumbs && breadcrumbs.map(function (_a, index) {
    var name = _a.name,
        to = _a.to;
    return react_1.default.createElement(Breadcrumb, {
      key: index
    }, node(name, to));
  }));
};

var templateObject_1, templateObject_2;